
import { NavLink, useNavigate } from 'react-router-dom'


import { LayoutDashboard, Building2, Users, Puzzle, KeyRound, LogOut, X, MessageSquare, Handshake, Receipt, UserPlus, PackagePlus, Shield, Settings, ArrowLeftRight, Ticket, Globe, ClipboardCheck, Grid3x3, Link2, FileStack, Wallet, Cpu, FileClock, CreditCard, HeartPulse } from 'lucide-react'
import { supabase } from '../lib/supabase'

const navItems = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/leads', icon: UserPlus, label: 'Leads' },
  { to: '/landing-pages', icon: Globe, label: 'Landing Pages' },
  { to: '/jumpstart/signups', icon: ClipboardCheck, label: 'JumpStart Signups' },
  { to: '/organizations', icon: Building2, label: 'Organizations' },
  { to: '/org-pulse', icon: HeartPulse, label: 'דופק ארגונים' },
  { to: '/users', icon: Users, label: 'Users' },
  { to: '/licensing', icon: KeyRound, label: 'Licensing' },
  { to: '/subscribers', icon: CreditCard, label: 'Subscribers' },
  { to: '/addons', icon: PackagePlus, label: 'Add-ons' },
  { to: '/migration/discovery', icon: ArrowLeftRight, label: 'Migration' },
  { to: '/coupons', icon: Ticket, label: 'Signup Coupons' },
  { to: '/affiliates', icon: Handshake, label: 'Affiliates' },
  { to: '/affiliate/partners', icon: Handshake, label: 'Affiliate Partners' },
  { to: '/affiliate/templates', icon: FileStack, label: 'Affiliate Templates' },
  { to: '/affiliate/payouts', icon: Wallet, label: 'Affiliate Payouts' },
  { to: '/trials', icon: Link2, label: 'Trial Invites' },
  { to: '/settings', icon: Settings, label: 'Settings' },
  { to: '/admin/broadcast-pace-approvals', icon: Shield, label: 'אישורי קצב מותאם' },
  { to: '/admin/audit', icon: Shield, label: 'Security' },
  { to: '/admin/activity-log', icon: FileClock, label: 'יומן פעילות' },
  { to: '/whatsapp', icon: MessageSquare, label: 'WhatsApp' },
  { to: '/jumpstart-chat', icon: MessageSquare, label: 'JumpStart Chat' },
  { to: '/partners', icon: Handshake, label: 'Partners' },
  { to: '/billing', icon: Receipt, label: 'Billing' },
  { to: '/modules', icon: Puzzle, label: 'Modules' },
  { to: '/modules-matrix', icon: Grid3x3, label: 'Modules Matrix' },
]

interface SidebarProps {
  onClose?: () => void
}

export default function Sidebar({ onClose }: SidebarProps) {
  const navigate = useNavigate()
  const handleLogout = async () => {
    await supabase.auth.signOut()
    navigate('/login')
  }

  const handleNav = () => {
    onClose?.()
  }

  return (
    <aside
      className="flex flex-col w-64 min-h-screen h-full"
      style={{ background: '#1a1d27', borderRight: '1px solid #2d3148' }}
    >
      {/* Logo + mobile close */}
      <div className="px-6 py-5 border-b flex items-center justify-between" style={{ borderColor: '#2d3148' }}>
        <div className="flex items-center gap-3">
          <div
            className="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-sm flex-shrink-0"
            style={{ background: '#6366f1' }}
          >
            O
          </div>
          <div>
            <div className="text-white font-semibold text-sm">Otomator</div>
            <div className="text-xs" style={{ color: '#9ca3af' }}>Admin Portal</div>
          </div>
        </div>
        {/* Close button — only shown on mobile */}
        {onClose && (
          <button
            onClick={onClose}
            className="lg:hidden p-1.5 rounded-lg transition-colors hover:bg-white/10"
            style={{ color: '#9ca3af' }}
          >
            <X size={18} />
          </button>
        )}
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto"><div dir="rtl" className="mb-4"><NavLink to="/command/development" onClick={handleNav} className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-white"><Cpu size={18}/>מרכז הפיקוד</NavLink><div className="ms-4 border-s border-white/10 ps-2">{[["development","מחלקת פיתוח"],["releases","שחרורים"],["status","מצב"]].map(([key,label])=><NavLink key={key} to={"/command/"+key} onClick={handleNav} className={({isActive})=>"block px-3 py-2.5 rounded-lg text-sm "+(isActive?"bg-indigo-500/20 text-indigo-200":"text-gray-400 hover:text-white")}>{label}</NavLink>)}</div></div>
        {navItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            onClick={handleNav}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                isActive ? 'text-white font-medium' : 'hover:text-white'
              }`
            }
            style={({ isActive }) => ({
              background: isActive ? '#6366f120' : 'transparent',
              color: isActive ? '#a5b4fc' : '#9ca3af',
            })}
          >
            <Icon size={18} />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* Logout */}
      <div className="px-3 py-4 border-t" style={{ borderColor: '#2d3148' }}>
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm w-full transition-colors hover:text-white"
          style={{ color: '#9ca3af' }}
        >
          <LogOut size={18} />
          Logout
        </button>
      </div>
    </aside>
  )
}
